import { render, staticRenderFns } from "./table.vue?vue&type=template&id=ec2eea42&scoped=true&lang=pug&"
import script from "./table.vue?vue&type=script&setup=true&lang=js&"
export * from "./table.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./table.vue?vue&type=style&index=0&id=ec2eea42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2eea42",
  null
  
)

export default component.exports